// extracted by mini-css-extract-plugin
export var phone = "_1f-0";
export var phoneDragging = "_1f-1";